<template>
  <div class="privacy-page">
    <header class="header">
      <button class="lang-btn" @click="toggleLang">{{ $t('common.langSwitch') }}</button>
    </header>

    <main class="content">
      <h1 class="title">{{ $t('privacy.title') }}</h1>
      <p class="meta">
        {{ $t('privacy.effectiveDate') }}：<strong>2026-03-03</strong>
        <!-- （{{ $t('privacy.effectiveDatePlaceholder') }}） -->
      </p>

      <p class="intro">{{ $t('privacy.intro') }}</p>

      <h2>{{ $t('privacy.section1Title') }}</h2>
      <h3>{{ $t('privacy.section1_1Title') }}</h3>
      <ul>
        <li v-for="(item, i) in $t('privacy.section1_1')" :key="'1_1-' + i">{{ item }}</li>
      </ul>
      <h3>{{ $t('privacy.section1_2Title') }}</h3>
      <ul>
        <li v-for="(item, i) in $t('privacy.section1_2')" :key="'1_2-' + i">
          {{ item }}
          <template v-if="i === 1">
            <a :href="$t('privacy.sentryUrl')" target="_blank" rel="noopener">{{ $t('privacy.sentryLinkText') }}</a>
          </template>
        </li>
      </ul>
      <h3>{{ $t('privacy.section1_3Title') }}</h3>
      <ul>
        <li v-for="(item, i) in $t('privacy.section1_3')" :key="'1_3-' + i">{{ item }}</li>
      </ul>
      <p class="no-collect">{{ $t('privacy.section1NoCollect') }}</p>

      <h2>{{ $t('privacy.section2Title') }}</h2>
      <ul>
        <li v-for="(item, i) in $t('privacy.section2List')" :key="'2-' + i">{{ item }}</li>
      </ul>
      <p class="no-use">{{ $t('privacy.section2NoUse') }}</p>

      <h2>{{ $t('privacy.section3Title') }}</h2>
      <p>{{ $t('privacy.section3') }}</p>

      <h2>{{ $t('privacy.section4Title') }}</h2>
      <p>{{ $t('privacy.section4Intro') }}</p>
      <ul>
        <li>
          {{ $t('privacy.section4Sentry') }}
          <a :href="$t('privacy.sentryUrl')" target="_blank" rel="noopener">{{ $t('privacy.sentryUrl') }}</a>
        </li>
        <li>
          {{ $t('privacy.section4Email') }}
          <a :href="$t('privacy.alibabaUrl')" target="_blank" rel="noopener">{{ $t('privacy.section4Alibaba') }}</a>。
        </li>
      </ul>
      <p>{{ $t('privacy.section4End') }}</p>

      <h2>{{ $t('privacy.section5Title') }}</h2>
      <p>{{ $t('privacy.section5Intro') }}</p>
      <ul>
        <li v-for="(item, i) in $t('privacy.section5List')" :key="'5-' + i">{{ item }}</li>
      </ul>
      <p>{{ $t('privacy.section5NoAuto') }}</p>

      <h2>{{ $t('privacy.section6Title') }}</h2>
      <p>{{ $t('privacy.section6') }}</p>

      <h2>{{ $t('privacy.section7Title') }}</h2>
      <p>{{ $t('privacy.section7') }}</p>

      <h2>{{ $t('privacy.section8Title') }}</h2>
      <p>{{ $t('privacy.section8Intro') }}</p>
      <div class="contact-box">
        <p v-if="$t('privacy.contactEmail')"><strong>{{ $t('privacy.contactEmail') }}</strong></p>
        <p v-if="$t('privacy.contactWeb')"><strong>{{ $t('privacy.contactWeb') }}</strong></p>
        <p v-if="$t('privacy.contactPhone')"><strong>{{ $t('privacy.contactPhone') }}</strong></p>
      </div>
      <p>{{ $t('privacy.section8End') }}</p>

      <p class="footer-meta">
        <strong>{{ $t('privacy.footerCompany') }}</strong><br />
        {{ $t('privacy.footerUpdate') }}
      </p>
    </main>

    <button v-show="showBackTop" type="button" class="back-top" :title="$t('common.backTop')" aria-label="Back to top"
      @click="scrollToTop">
      ↑
    </button>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      showBackTop: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    toggleLang() {
      const next = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = next
      localStorage.setItem('grabgo_privacy_lang', next)
    },
    onScroll() {
      this.showBackTop = window.scrollY > 300
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
}
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
  background: #fafafa;
}

.header {
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 12px 20px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.lang-btn {
  padding: 6px 14px;
  font-size: 14px;
  color: #0066cc;
  background: transparent;
  border: 1px solid #0066cc;
  border-radius: 6px;
  cursor: pointer;
}

.lang-btn:hover {
  background: #e6f0ff;
}

.content {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 20px 80px;
  line-height: 1.7;
  color: #333;
}

.title {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #111;
}

.meta {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 2rem;
}

.intro {
  margin-bottom: 1.5rem;
}

h2 {
  font-size: 1.15rem;
  margin-top: 2rem;
  margin-bottom: 0.75rem;
  color: #222;
}

h3 {
  font-size: 1rem;
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  color: #333;
}

p,
li {
  margin-bottom: 0.75rem;
}

ul {
  padding-left: 1.5rem;
}

a {
  color: #0066cc;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.no-collect,
.no-use {
  font-weight: 500;
}

.contact-box {
  background: #f0f4f8;
  padding: 1rem 1.25rem;
  border-radius: 8px;
  margin-top: 1rem;
}

.footer-meta {
  margin-top: 2rem;
  color: #666;
  font-size: 0.9rem;
}

.back-top {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #0066cc;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 18px;
  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.4);
}

.back-top:hover {
  background: #0052a3;
}
</style>
